import React, 
      { useState , 
        useEffect,
        useRef , }        from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Container         from '@mui/material/Container'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import { useHistory }    from "react-router-dom"
import GBTitle           from './GBTitle'
import GBOpening         from "./GBOpening"
import CalculationSelect from './CalculationModeSelect'
import GameMain          from "./GameMain"
import GameStart         from "./GameStart"
import GBDirectionalPad  from "../GB_Button/GB_DirectionalPadKey"
import GameModeSelect    from './GameModeSelect'
import KanjiGame         from "./KanjiGame"
import GakunenSelect     from './GakunenSelect'
import PokemonData       from './PokemonData'
import StartTyping       from './StartTyping'
import CountDown         from './CountDown'
import Typing            from './Typing'
import EndTyping         from './EndTyping'
import A_Button          from '../GB_Button/A_Button'
import B_Button          from '../GB_Button/B_Button'
import SELECT_Button     from '../GB_Button/SELECT_Button'
import START_Button      from '../GB_Button/START_Button'
import store             from '../../store'
import '../../App.css'
import '../../style.css';
import {GBUI_ROOT_BOX_SX           ,
        GBUI_CONTAINER_SX          ,
        GBUI_BODY_BOX_SX           ,
        GBUI_SCREEN_PAPER_SX       ,
        GBUI_POWER_DOT_TEXT_SX     ,
        GBUI_POWER_LABEL_TEXT_SX   ,
        GBUI_GAMEBOY_LOGO_TEXT_SX  ,
        GBUI_COLOR_LOGO_TEXT_SX    ,
        GBUI_NINTENDO_LOGO_TEXT_SX , } from '../Style/GBUIStyle'
import { GAME_DESCRIPTION_HEADING_SX } from '../Style/CommonStyle';
import {UIMODE_OPENING,
        UIMODE_CALUCSELECT,
        UIMODE_SELECT,
        UIMODE_MAIN,
        UIMODE_TITLE,
        UIMODE_START,
        UIMODE_KANJI_GAME,
        UIMODE_GAKUNEN_SELECT,
        UIMODE_POKEMON_ZUKAN,
        TEST_MODE,
        MUSIC_OPENING,
        MUSIC_GAME,
        MUSIC_POKEMON_BATLE,
        MUSIC_POKEMON_VICTORY,
        GAME_MODES,
        GRADES,
        CALC_TYPES,
        UIMODE_TYPING_GAME,
        UIMODE_COUNTDOWN,
        UIMODE_TYPING_MAIN,
        UIMODE_TYPING_END , } from "../Contants";

function GBUI() {
  const [currentUI, setCurrentUI] = useState(UIMODE_TITLE);
  const [localpokemondata, setLocalPokemonData] = useState([]);
  const history = useHistory()

  // ゲームモードをローカルstateで管理
  const [gameMode, setGameMode] = useState(
    store.getState().GameModeSelect || "kokugo"
  );

  // 学年を管理する state（初期値は1年生）
  const [gakunen, setGakunen] = useState(
    store.getState().GakunenSelect || "1"
  );

  // 計算種類（たし算/ひき算/かけ算）を管理する state
  const [calcType, setCalcType] = useState(
    store.getState().CalcSelect || "tashi"
  );

  // YES / NO（ゲーム開始確認用）
  const [startYesNo, setStartYesNo] = useState(
    store.getState().SelectYesNo || "yes"
  )

  console.log("==================================")
  console.log("選択中のゲームモード:");
  console.log("  store.getState().GameModeSelect:", store.getState().GameModeSelect);
  console.log("  gameMode:", gameMode);

  console.log("選択中の計算式:");
  console.log("  store.getState().CalcSelect:", store.getState().CalcSelect);
  console.log("  calcType:", calcType);

  console.log("選択中の学年:");
  console.log("  gakunen:", gakunen);
  
  console.log("YES NO ラベル" , store.getState().SelectYesNo);

  // D-Pad 上
  const handleDpadUp = () => {
    console.log("D-Pad 上押下");

    // ゲームモード選択画面
    if (currentUI === UIMODE_SELECT) {
      const currentIndex = GAME_MODES.indexOf(gameMode);
      const nextIndex =
        (currentIndex - 1 + GAME_MODES.length) % GAME_MODES.length;
      setGameMode(GAME_MODES[nextIndex]);
      return;
    }

    // 学年選択画面の場合
    if (currentUI === UIMODE_GAKUNEN_SELECT) {
      const currentIndex = GRADES.indexOf(gakunen);
      const nextIndex =
        (currentIndex - 1 + GRADES.length) % GRADES.length;
      setGakunen(GRADES[nextIndex]);
      return;
    }

    // 計算種類選択画面（けいさんのしゅるい）の場合
    if (currentUI === UIMODE_CALUCSELECT) {
      const currentIndex = CALC_TYPES.indexOf(calcType);
      const nextIndex =
        (currentIndex - 1 + CALC_TYPES.length) % CALC_TYPES.length;
      setCalcType(CALC_TYPES[nextIndex]);
      return;
    }

    // ゲーム開始確認画面（YES/NO）の場合
    if (currentUI === UIMODE_START) {
      const next = startYesNo === "yes" ? "no" : "yes";
      setStartYesNo(next);
      store.getState().SelectYesNo = next;   // 互換用
      return;
    }
  };

  // D-Pad 下
  const handleDpadDown = () => {
    console.log("D-Pad 下押下");
    // ゲームモード選択画面の場合
    if (currentUI === UIMODE_SELECT) {
      const currentIndex = GAME_MODES.indexOf(gameMode);
      const nextIndex = (currentIndex + 1) % GAME_MODES.length;
      setGameMode(GAME_MODES[nextIndex]);
      return;
    }
    // 学年選択画面の場合
    if (currentUI === UIMODE_GAKUNEN_SELECT) {
      const currentIndex = GRADES.indexOf(gakunen);
      const nextIndex = (currentIndex + 1) % GRADES.length;
      setGakunen(GRADES[nextIndex]);
      return;
    }
    // 計算種類選択画面（けいさんのしゅるい）の場合
    if (currentUI === UIMODE_CALUCSELECT) {
      const currentIndex = CALC_TYPES.indexOf(calcType);
      const nextIndex = (currentIndex + 1) % CALC_TYPES.length;
      setCalcType(CALC_TYPES[nextIndex]);
      return;
    }
    // ゲーム開始確認画面（YES/NO）の場合
    if (currentUI === UIMODE_START) {
      const next = startYesNo === "yes" ? "no" : "yes";
      setStartYesNo(next);
      store.getState().SelectYesNo = next;   // 互換用
      return;
    }
  };

  // 音楽が流れる
  const [audio]           = useState(new Audio(MUSIC_OPENING))
  const [gameMusic]       = useState(new Audio(MUSIC_GAME))
  const [battleAudio]     = useState(new Audio(MUSIC_POKEMON_BATLE))
  const [pokemonVictory ] = useState(new Audio(MUSIC_POKEMON_VICTORY))
  // const [isPlaying, setIsPlaying] = useState(false)

  // オープニング音楽を再生
  const startaudioPlay = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    audio.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      audio.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }
  // ゲーム選択音楽を再生
  const startGameMusicPlay = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    gameMusic.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      gameMusic.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // すべての音楽を停止する
  const AllMusicPause = () => {
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
  }

  // 初回起動時の処理
  useEffect(() => {
    // store.getState().GameUI         = UIMODE_TITLE
    // コンポーネントがマウントされたときに音楽を再生
    audio.pause()           // 停止
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止

    // setIsPlaying(true)

    // コンポーネントがアンマウントされるときに音楽を停止
    return () => {
      audio.pause() // 停止
    }
  }, [audio]);

  // ゲームモードが変わったら store にも反映
  useEffect(() => {
    store.getState().GameModeSelect = gameMode
  }, [gameMode])

  // 学年が変わったら store にも反映
  useEffect(() => {
    store.getState().GakunenSelect = gakunen
  }, [gakunen])

  // 計算種類が変わったら store にも反映
  useEffect(() => {
    store.getState().CalcSelect = calcType
  }, [calcType])

  // Aボタンクリック時の処理
  const handleClick_A_Button = () => {
    switch (currentUI) {
      // ゲーム選択画面表示の場合★
          case UIMODE_START:
            console.log("YES or NO =>", store.getState().SelectYesNo);
            if (store.getState().SelectYesNo == "yes") {
              // 「はい」が選ばれている場合

              // ここで最終的な選択値を store に確定させる
              store.getState().GameModeSelect = gameMode
              store.getState().GakunenSelect  = gakunen
              store.getState().CalcSelect     = calcType

              if (gameMode === "sansuu") {
                // さんすうモード → 計算ゲーム
                AllMusicPause();
                store.getState().GameUI = UIMODE_MAIN;
                setCurrentUI(UIMODE_MAIN);
              } else if (gameMode === "kokugo") {
                // こくごモード → 漢字の画数ゲーム
                AllMusicPause();
                store.getState().GameUI = UIMODE_KANJI_GAME;
                setCurrentUI(UIMODE_KANJI_GAME);
              } else if (gameMode === "typing") {
                // タイピングゲームモード → タイピングゲーム開始画面
                AllMusicPause();
                store.getState().GameUI = UIMODE_TYPING_GAME;
                setCurrentUI(UIMODE_TYPING_GAME);
              }
            } else {
              // 「いいえ」 → オープニング画面に戻る
              startaudioPlay();
              store.getState().GameUI = UIMODE_OPENING;
              setCurrentUI(UIMODE_OPENING);
            }
            break;

          // ゲームモード選択画面(こくご/さんすう/ずかんをみる/タイピング)の場合
          case UIMODE_SELECT:
            // ゲームモードを store に確定
            store.getState().GameModeSelect = gameMode

            if (gameMode === "sansuu") {
              store.getState().GameUI = UIMODE_CALUCSELECT;
              setCurrentUI(UIMODE_CALUCSELECT);
            } else if (gameMode === "kokugo") {
              store.getState().GameUI = UIMODE_GAKUNEN_SELECT;
              setCurrentUI(UIMODE_GAKUNEN_SELECT);
            } else if (gameMode === "zukan") {
              store.getState().GameUI = UIMODE_POKEMON_ZUKAN;
              setCurrentUI(UIMODE_POKEMON_ZUKAN);
            } else if (gameMode === "typing") {
              store.getState().GameUI = UIMODE_START;
              setCurrentUI(UIMODE_START);
            }
            break;    

          // 計算式選択画面表示(たしざん/ひきざん/かけざん)の場合
          case UIMODE_CALUCSELECT:
            // 計算種類を確定して、オープニングに戻る
            store.getState().CalcSelect = calcType
            // startaudioPlay()
            store.getState().GameUI = UIMODE_START
            setCurrentUI(UIMODE_START)
            console.log("計算種類を確定:", calcType)
            break
          
          // 学年選択画面表示の場合
          case UIMODE_GAKUNEN_SELECT:
            // 学年を確定して、オープニングに戻る
            store.getState().GakunenSelect = gakunen
            // startaudioPlay()
            store.getState().GameUI = UIMODE_START
            setCurrentUI(UIMODE_START)
            console.log("学年を確定:", gakunen)
            break
          
          default:
        break
    }
  }

  // Bボタンクリック時の処理
  const handleClick_B_Button = () => {
    switch (currentUI) {
      // オープニング画面表示の場合
      case UIMODE_SELECT:
      // ポケモン図鑑表示の場合
      case UIMODE_POKEMON_ZUKAN:
      // タイピングゲーム画面表示の場合
      case UIMODE_TYPING_GAME:
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break

      // ゲーム選択画面表示の場合
      case UIMODE_START:
      // 計算の種類選択画面表示の場合
      case UIMODE_CALUCSELECT:
      // 学年選択画面表示
      case UIMODE_GAKUNEN_SELECT:
        store.getState().GameUI = UIMODE_SELECT
        setCurrentUI(UIMODE_SELECT)
        console.log("画面状態：",store.getState().GameUI)
        break
        
      // ゲーム実行中画面表示(計算ゲーム)の場合
      case UIMODE_MAIN:
      // ゲーム実行中画面表示(漢字ゲーム)の場合
      case UIMODE_KANJI_GAME:
        window.location.reload()
        break

      default:
        break
    }
  }
  
  // 十字ボタンクリック時の処理
  const handleClick_DirectionalPadKey = () => {
    console.log("十字キー")
  }
  
  // STARTボタンクリック時の処理
  const handleClickStartButton = () => {
    switch (currentUI) {
      // タイトル画面表示
      case UIMODE_TITLE:
        console.log("UIMODE_TITLEを通過")
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break

      // オープニング画面表示
      case UIMODE_OPENING:
        // zukan を「こくご1年生」に強制変換する
        if (gameMode === "zukan") {
          // store 側もローカル state 側も両方そろえておく
          store.getState().GameModeSelect = "kokugo"
          store.getState().GakunenSelect  = "1"
          setGameMode("kokugo")
          setGakunen("1")
        }

        console.log("UIMODE_OPENINGを通過")
        startGameMusicPlay() // 再生
        store.getState().GameUI = UIMODE_SELECT
        setCurrentUI(UIMODE_SELECT)
        console.log("画面状態：",store.getState().GameUI)
        break

      // ゲーム選択表示
      case UIMODE_START:
        console.log("UIMODE_STARTを通過")
        startaudioPlay() // 再生
        store.getState().GameUI = UIMODE_OPENING
        setCurrentUI(UIMODE_OPENING)
        console.log("画面状態：",store.getState().GameUI)
        break

      default:
        break
    }
  }

  // SELECT_Buttonがクリックされたときの処理を記述
  const handleClickSelectButton = () => {
    switch (currentUI) {
      // // オープニング画面表示の場合
      // case UIMODE_OPENING:
      //   startGameMusicPlay() // 再生
      //   store.getState().GameUI = UIMODE_SELECT
      //   setCurrentUI(UIMODE_SELECT)
      //   console.log("画面状態：",store.getState().GameUI)
      //   break

      //   // ゲーム選択画面の場合
      // case UIMODE_SELECT:
      //   startaudioPlay() // 再生
      //   store.getState().GameUI = UIMODE_OPENING
      //   setCurrentUI(UIMODE_OPENING)
      //   console.log("画面状態：",store.getState().GameUI)
      //   break

        // ポケモン図鑑画面の場合
      case UIMODE_POKEMON_ZUKAN:
        // ローカルストレージをクリア
        console.log("ローカルストレージをクリア")
        localStorage.removeItem('pokemondata')
        setLocalPokemonData([])
        break

      default:
        break
    }
  }

  // currentUIに基づいて表示するコンポーネントを選択
  const renderUIComponent = () => {
    switch (currentUI) {
      // スタートボタンを押してね画面
      case UIMODE_TITLE:
        return <GBTitle />
      // ゲームタイトル画面
      case UIMODE_OPENING:
        return <GBOpening />
      // ゲーム画面
      case UIMODE_MAIN:
        return <GameMain />
      // 計算式選択画面
      case UIMODE_CALUCSELECT:
        return <CalculationSelect calcType={calcType} setCalcType={setCalcType}/>
      // ゲームモード選択画面
      case UIMODE_SELECT:
        return <GameModeSelect gameMode={gameMode} setGameMode={setGameMode} />
      // ゲーム開始選択画面
      case UIMODE_START:
        return <GameStart startYesNo={startYesNo} setStartYesNo={setStartYesNo} />
      // 学年選択画面
      case UIMODE_GAKUNEN_SELECT:
        return <GakunenSelect gakunen={gakunen} setGakunen={setGakunen} />
      // 漢字ゲーム画面
      case UIMODE_KANJI_GAME:
        return <KanjiGame />

      // ポケモン図鑑画面
      case UIMODE_POKEMON_ZUKAN:
        return <PokemonData />

      // タイピングスタート画面
      case UIMODE_TYPING_GAME:
        // スペースを押すとカウントダウン画面へ遷移
        return (
          <StartTyping
            onSpace={() => {
              store.getState().GameUI = UIMODE_COUNTDOWN
              setCurrentUI(UIMODE_COUNTDOWN)
            }}
          />
        )

      // カウントダウン画面
      case UIMODE_COUNTDOWN:
        return (
          <CountDown
            start={3}
            onComplete={() => {
              AllMusicPause()
              store.getState().GameUI = UIMODE_TYPING_MAIN
              setCurrentUI(UIMODE_TYPING_MAIN)
            }}
          />
        )
      // タイピングメイン画面
      case UIMODE_TYPING_MAIN:
        return <Typing />
      // タイピング終了画面
      case UIMODE_TYPING_END:
        return <EndTyping />

        default:
      return null;
    }
  }

  // テスト画面
  const TESTMode = () => {
    store.getState().GameUI = UIMODE_POKEMON_ZUKAN
    setCurrentUI(UIMODE_POKEMON_ZUKAN)
    console.log("画面状態：", store.getState().GameUI)
  }

return (
  <Box sx={GBUI_ROOT_BOX_SX}>
    <Container maxWidth="lg" sx={GBUI_CONTAINER_SX}>
      {/* 本体外枠 */}
      <Box sx={GBUI_BODY_BOX_SX}>
        <Grid container spacing={2}>
          <Grid item xs={12} align="center"></Grid>
        </Grid>

        {/* 画面外枠 */}
        <Paper sx={GBUI_SCREEN_PAPER_SX}>
          {/* POWERフォント */}
          <Typography sx={GBUI_POWER_DOT_TEXT_SX}>
            <span style={{ color: 'red' }}>●</span> ) ) )
          </Typography>

          <Typography sx={GBUI_POWER_LABEL_TEXT_SX}>
            POWER
          </Typography>

          {/* 画面表示 */}
          {renderUIComponent()}

          {/* ゲームボーイのロゴ */}
          <Grid container spacing={0}>
            <Typography sx={GBUI_GAMEBOY_LOGO_TEXT_SX}>
              GAME BOY
            </Typography>
            <Typography sx={GBUI_COLOR_LOGO_TEXT_SX}>
              <span style={{ color: '#FB4E8B' }}>C</span>
              <span style={{ color: '#AE97F1' }}>O</span>
              <span style={{ color: '#BBE880' }}>L</span>
              <span style={{ color: '#FAEB67' }}>O</span>
              <span style={{ color: '#8CD0FF' }}>R</span>
            </Typography>
          </Grid>
        </Paper>

        {/* Nintendo ロゴ */}
        <Typography sx={GBUI_NINTENDO_LOGO_TEXT_SX}>
          Nintendo
        </Typography>

        {/* 十字キー(上ボタン) */}
        <GBDirectionalPad
          onClick={handleClick_DirectionalPadKey} // 共通ログ用
          onUp={handleDpadUp}
          onDown={handleDpadDown}
        />

        {/* Aボタン */}
        <A_Button 
          // onClick={(event) => handleClick_A_Button({ key: 'Enter', target: { value: 'yes' } })}/>
          onClick={(event) => handleClick_A_Button()}/>

        {/* Bボタン */}
        <B_Button 
          onClick={(event) => handleClick_B_Button()}/>
      
        {/* SELECTボタン */}
        <SELECT_Button 
          onClick={handleClickSelectButton}/>
        {/* <SELECT_Button/> */}

        {/* STARTボタン */}
        <START_Button
          onClick={handleClickStartButton} />

        <Grid container spacing={2}>
          <Grid item xs={12} align="center">
          </Grid>
        </Grid>
      </Box>
      
      {/* 操作案内 */}
      <Grid container spacing={2}>
        <Grid item xs={12} align="left">
          <Typography sx={GAME_DESCRIPTION_HEADING_SX}>
            ◆ゲームのせつめい
          </Typography>
        </Grid>
      </Grid>
      <br/>
      <Grid container spacing={2}>
        <Grid item xs={12} align="left">
          <Typography>
            こくごやさんすう、タイピングでポケモンをゲットするゲームです。<br/>
            ゲットしたポケモンはポケモン図鑑で確認できます。
          </Typography>
        </Grid>
      </Grid>
      
      <Grid container spacing={2}>
        <Grid item xs={12} align="left">
          <Typography sx={GAME_DESCRIPTION_HEADING_SX}>
            ◆ボタンのせつめい
          </Typography>
        </Grid>
      </Grid>
      <br/>
      <Grid container spacing={2}>
        <Grid item xs={12} align="left">
          <Typography>
            【十字ボタン】
          </Typography>
          <Typography>
            モードせんたくをするときに使います。<br />
          </Typography>
        </Grid>
        <Grid item xs={12} align="left">
          <Typography>
            【Aボタン】
          </Typography>
          <Typography>
            モードせんたくで決定するときに使います。<br />
          </Typography>
        </Grid>
        <Grid item xs={12} align="left">
          <Typography>
            【Bボタン】
          </Typography>
          <Typography>
            キャンセルするときに使います。<br />
          </Typography>
        </Grid>
        <Grid item xs={12} align="left">
          <Typography>
            【SELECTボタン】
          </Typography>
          <Typography>
            ポケモン図鑑のデータをクリアするときに使います。<br />
          </Typography>
        </Grid>
        <Grid item xs={12} align="left">
          <Typography>
            【STARTボタン】
          </Typography>
          <Typography>
            ゲームモードを選択します。<br />
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} align="left">
          <Typography sx={GAME_DESCRIPTION_HEADING_SX}>
            ◆ゲームモードのせつめい
          </Typography>
        </Grid>
      </Grid>
      <br/>
      <Grid container spacing={2}>
        <Grid item xs={12} align="left">
          <Typography>
            【さんすうモード】
          </Typography>
          <Typography>
            たしざん、ひきざん、かけざんで遊べます。<br />
            正解するとポケモンがゲットできます。<br />
            ゲットしたポケモンはポケモン図鑑で確認できます。<br />
          </Typography>
        </Grid>
        <Grid item xs={12} align="left">
          <Typography>
            【こくごモード】
          </Typography>
          <Typography>
            漢字の画数を答えるゲームです。<br />
            表示する漢字は小学1年生から6年生まで選べます。<br />
            正解するとポケモンがゲットできます。<br />
            ゲットしたポケモンはポケモン図鑑で確認できます。<br />  
          </Typography>
        </Grid>
        <Grid item xs={12} align="left">
          <Typography>
            【ポケモンずかん】
          </Typography>
          <Typography>
            さんすうモード、こくごモードでゲットしたポケモンを確認できます。<br />
            ポケモン図鑑をリセットしたい場合は、SELECTボタンをクリックしてください。<br />
          </Typography>
        </Grid>
        <Grid item xs={12} align="left">
          <Typography>
            【タイピング】
          </Typography>
          <Typography>
            つぎつぎとポケモンが登場します。<br />
            名前をタイピングしてポケモンをゲットしましょう。<br />
            たくさんゲットするとポケモン図鑑に登録できます。<br />
          </Typography>
        </Grid>
      </Grid>
    </Container>
  </Box>
  );
}

export default GBUI;
